import defaultLocale from './default';
export * from './types';
export var locale = defaultLocale;